//替换所有空格为空字符
export const clearTrim = function(val){
        if (val !== null && val !== undefined && val !== "") {
            return val.toString().replace(/\s/g, '');
        }
        return "";
}
//
export const isNullOrUndefined = function(val){
    return (val === null || val === undefined || val === "undefined" || clearTrim(val) === "") ? true : false;
}

export const vaildIdCard = function(idcard){
    if (isNullOrUndefined(idcard)) {
        return {
            code:1,
            message: '身份证号不能为空，请输入正确的身份证号！'
        }
    }
    // 台湾、香港身份证号暂时处理 以后统一处理下
    if (idcard.length == 10) {
        var card = idcard.substr(0, 1)
        //alert(card);
        var card2 = idcard.substr(1, idcard.lenth)
        //alert(card2);
        if (/^[A-Za-z]+$/.test(card.toString()) && /^\d+$/.test(card2.toString())) {
            //alert(11);
            return {
                code:0,
            }
        } else {
            return {
                code:1,
                message: '身份证号格式不正确，请输入正确的身份证号！'
            }
        }
    }

    if (idcard.length !== 15 && idcard.length !== 18) {
        return {
            code:1,
            message: '身份证号格式不正确，请输入正确的身份证号！'
        }
    }

    var area = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
    var pNO = idcard.substr(0, 2);
    if (isNaN(pNO) || area[parseInt(pNO)] == null) {
        return {
            code:1,
            message: '身份证号不正确(地区非法)，请输入正确的身份证号！'
        }
    }

    var birth = "";
    var month = "";
    var day = "";

    if (idcard.length === 15) {
       
        var pattern = /^\d{15}$/;
        if (pattern.exec(idcard) === null) {
            return {
                code:1,
                message: '15位身份证号码必须为数字，请输入正确的身份证号！'
            }
        }
        birth = parseInt("19" + idcard.substr(6, 2));
        month = idcard.substr(8, 2);
        day = parseInt(idcard.substr(10, 2));
        switch (month) {
            case '01':
            case '03':
            case '05':
            case '07':
            case '08':
            case '10':
            case '12':
                {
                    if (day > 31) {
                        return {
                            code:1,
                            message: '输入身份证号码不格式正确，请输入正确的身份证号！'
                        }
                    }
                    break;
                }
            case '04':
            case '06':
            case '09':
            case '11':
                {
                    if (day > 30) {
                        return {
                            code:1,
                            message: '输入身份证号码不格式正确，请输入正确的身份证号！'
                        }
                    }
                    break;
                }
            case '02':
                {
                    if ((birth % 4 == 0 && birth % 100 != 0) || birth % 400 == 0) {
                        if (day > 29) {
                            return {
                                code:1,
                                message: '输入身份证号码不格式正确，请输入正确的身份证号！'
                            }
                        }
                    }
                    else {
                        if (day > 28) {
                            return {
                                code:1,
                                message: '输入身份证号码不格式正确，请输入正确的身份证号！'
                            }
                        }
                    }
                    break;
                }
            default:
                {
                    return {
                        code:1,
                        message: '输入身份证号码不格式正确，请输入正确的身份证号！'
                    }
                }
        }
        var nowYear = new Date().getFullYear();
        if (nowYear - parseInt(birth) < 15 || nowYear - parseInt(birth) > 100) {
            return {
                code:1,
                message: '输入身份证号码不格式正确，请输入正确的身份证号！'
            }
        }
        return {
            code: 0,
            data: { "province": pNO, "YMD": birth + "-" + month + "-" + day, "sex": idcard.substr(idcard.length - 1) }
        }
    }

    var Wi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1);
    var lSum = 0;
    var nNum = 0;
    for (let i = 0; i < 17; ++i) {
        if (idcard.charAt(i) < '0' || idcard.charAt(i) > '9') {
            return {
                code:1,
                message: '身份证号码不正确，请输入正确的身份证号！'
            }
        }
        else {
            nNum = idcard.charAt(i) - '0';
        }
        lSum += nNum * Wi[i];
    }
    if (idcard.charAt(17) === 'X' || idcard.charAt(17) === 'x') {
        lSum += 10 * Wi[17];
    }
    else if (idcard.charAt(17) < '0' || idcard.charAt(17) > '9') {
        return {
            code:1,
            message: '身份证号码不正确，请输入正确的身份证号！'
        }
    }
    else { lSum += (idcard.charAt(17) - '0') * Wi[17]; }

    if (!((lSum % 11) === 1)) { 
        return {
            code:1,
            message: '身份证号码不正确，请输入正确的身份证号！'
        }
    }
    birth = parseInt(idcard.substr(6, 4));
    month = idcard.substr(10, 2);
    day = idcard.substr(12, 2);
    return {
        code: 0,
        data: { "province": pNO, "YMD": birth + "-" + month + "-" + day, "sex": idcard.substr(idcard.length - 2, 1) }
    }
}